import type { DashboardSendByDay } from '@common/types/insights';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface Props {
    days: DashboardSendByDay[];
    bestDay: string | null;
}

export default function DayOfWeekBars({ days, bestDay }: Props) {
    const theme = useTheme();
    const maxSent = Math.max(...days.map((d) => d.sent), 1);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
            {days.map((day) => {
                const isBest = bestDay != null && day.day === bestDay;
                const pct = (day.sent / maxSent) * 100;
                return (
                    <Box key={day.day} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography
                            variant="caption"
                            sx={{ width: 32, color: theme.palette.text.secondary, flexShrink: 0 }}
                        >
                            {day.day.slice(0, 3)}
                        </Typography>
                        <Box
                            sx={{
                                height: 14,
                                width: `${pct}%`,
                                minWidth: day.sent > 0 ? 4 : 0,
                                borderRadius: 1,
                                backgroundColor: isBest
                                    ? theme.palette.primary.main
                                    : `${theme.palette.primary.main}40`,
                            }}
                        />
                        <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                            {day.sent}
                        </Typography>
                    </Box>
                );
            })}
            {bestDay && (
                <Typography variant="caption" sx={{ color: theme.palette.text.secondary, mt: 0.5 }}>
                    ● your best day to send (highest completion rate)
                </Typography>
            )}
        </Box>
    );
}
